const house = {
    Gryffindor : "",
    Hufflepuff : "#ffb039",
    Ravenclaw : "#173250",
    Slytherin : "#0c3d37",
}

export const members = [
  {
    id: 1,
    name: "LEE AYOUNG",
    role: "Founder / UI Designer",
    image: "../images/TeamPhoto/ayoung.png",
    hover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/ayoung2.png";
    },
    unhover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/ayoung.png";
    },
    color: house.Hufflepuff,
  },
  {
    id: 2,
    name: "KIM DOYON",
    role: "CTO",
    image: "../images/TeamPhoto/doyon.png",
    hover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/doyon2.png";
    },
    unhover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/doyon.png";
    },
    color: house.Ravenclaw,
  },
  {
    id: 3,
    name: "DANG BYEONJIN",
    role: "UI Developer",
    image: "../images/TeamPhoto/byeongjin.png",
    hover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/byeongjin2.png";
    },
    unhover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/byeongjin.png";
    },
    color: house.Hufflepuff,
  },
  {
    id: 4,
    name: "PARK JUNGAH",
    role: "Project Manager",
    image: "../images/TeamPhoto/jungah.png",
    hover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/jungah2.png";
    },
    unhover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/jungah.png";
    },
    color: house.Ravenclaw,
  },
  {
    id: 5,
    name: "PARK JIYUN",
    role: "Front-end Developer",
    image: "../images/TeamPhoto/jiyun.png",
    hover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/jiyun.png";
    },
    unhover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/jiyun2.png";
    },
    color: house.Slytherin,
  },
  {
    id: 6,
    name: "SANG HANGYU",
    role: "Dev Assist",
    image: "../images/TeamPhoto/hangyu.png",
    hover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/hangyu2.png";
    },
    unhover: function abc(e) {
      e.currentTarget.src = "../images/TeamPhoto/hangyu.png";
    },
    color: house.Ravenclaw,
  },
];


export default members;